// Which App Store app each store's visitors are pointed at, for the iOS Smart
// App Banner (<meta name="apple-itunes-app">) and the App Store links in
// src/utils/storeLinks.js. CommonJS so scripts/prerender-meta.js can write
// the same banner into the prerendered pages.
//
// Two iOS apps, each in its own App Store storefront:
// - 1604744564 "Fleek: Manage Subscriptions" (com.fleek.ios), India.
// - 6472657311 "Subscription Tracker: Fleek" (app.getfleek.fleekUSA), US.
// The US store gets the US app; every other store gets the app storeLinks.js
// already sends App Store clicks to, the India one. Safari only draws the
// banner when the app is sold in the visitor's own storefront, so a store
// whose storefront lacks the app simply shows no banner.

const APP_STORE_IDS = {
  IN: '1604744564',
  US: '6472657311',
};

const DEFAULT_APP_STORE_ID = APP_STORE_IDS.IN;

/** The App Store app id for a store (market code), e.g. "6472657311" for US. */
const appStoreIdFor = (market) => APP_STORE_IDS[String(market || '').trim().toUpperCase()] || DEFAULT_APP_STORE_ID;

/**
 * The apple-itunes-app meta content for a store, with the page's URL as the
 * app-argument so the app can open the same page. No URL, no app-argument.
 */
const smartBannerContent = (market, url) => {
  const id = appStoreIdFor(market);
  return url ? `app-id=${id}, app-argument=${url}` : `app-id=${id}`;
};

module.exports = { APP_STORE_IDS, DEFAULT_APP_STORE_ID, appStoreIdFor, smartBannerContent };
